<template>
  <v-content>
    <div class="home-grid" @click="startScreenTouched">
      <image-carousel :display-time="20" />
      <div class="priority-listing-slot">
        <transition name="listing-fade" mode="out-in">
          <div
            v-if="topListing"
            :key="topListing.id"
            @click.stop="navigateToListing(topListing)"
          >
            <fma-screensaver-listing :listing="topListing" />
          </div>
        </transition>
      </div>
      <div class="center-card-wrapper">
        <v-card flat tile color="#FFFFFFCC" class="heavy-shadow">
          <v-layout
            column
            align-stretch
            justify-center
            class="ma-0 text-xs-center"
          >
            <v-flex>
              <div
                id="fort-george-g-meade"
                class="grey--text text--darken-2 text-uppercase"
              >
                Fort George G. Meade
              </div>
            </v-flex>
            <v-flex>
              <div
                id="resiliency-services"
                class="secondary--text font-weight-bold"
              >
                <div id="resiliency">Resiliency</div>
                <div id="services">Services</div>
              </div>
            </v-flex>
            <v-flex>
              <v-btn
                depressed
                large
                block
                color="primary"
                class="ma-0 fma-block-button"
              >
                Touch to start
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </div>
      <div class="priority-listing-slot">
        <transition name="listing-fade" mode="out-in">
          <div
            v-if="bottomListing"
            :key="bottomListing.id"
            @click.stop="navigateToListing(bottomListing)"
          >
            <fma-screensaver-listing :listing="bottomListing" />
          </div>
        </transition>
      </div>
    </div>
  </v-content>
</template>

<script>
import axios from "axios";
import ImageCarousel from "@/components/ImageCarousel.vue";
import FmaScreensaverListing from "@/components/FmaScreensaverListing.vue";
import { mapState, mapGetters } from "vuex";

export default {
  components: {
    ImageCarousel,
    FmaScreensaverListing
  },
  data() {
    return {
      currentIndex: 0,
      rotationInterval: null
    };
  },
  computed: {
    ...mapState({ listings: state => state.listings }),
    ...mapGetters(["baseUrl"]),
    priorityListings() {
      return this.listings.filter(l => l.priority > 0);
    },
    topListing() {
      if (!this.priorityListings.length) return null;
      return this.priorityListings[
        this.currentIndex % this.priorityListings.length
      ];
    },
    bottomListing() {
      if (!this.priorityListings.length) return null;
      return this.priorityListings[
        (this.currentIndex + 1) % this.priorityListings.length
      ];
    }
  },
  created() {
    this.$store.dispatch("fetchListings");
  },
  mounted() {
    this.rotationInterval = setInterval(() => {
      this.currentIndex++;
    }, 30000);
  },
  beforeDestroy() {
    clearInterval(this.rotationInterval);
  },
  methods: {
    startScreenTouched() {
      this.$router.push({ name: "Categories" });
    },
    async navigateToListing(listing) {
      try {
        const response = await axios.get(
          `${this.baseUrl}/listings/${listing.id}/categories`
        );
        const categories = response.data.data;
        if (!categories.length) return;
        this.$router.push({
          name: "Listings",
          params: { categoryId: categories[0].id },
          query: { openListing: listing.id }
        });
      } catch (err) {
        console.error("Failed to fetch categories for listing:", err);
      }
    }
  }
};
</script>

<style scoped lang="less">
@import "../assets/global.less";

#fort-george-g-meade {
  font-size: 18px;
  letter-spacing: 4px;
  margin-top: 10px;
  margin-bottom: 4px;
  margin-left: 20px;
  margin-right: 20px;
}

#resiliency-services {
  font-size: 64px;
  #resiliency {
    margin-top: -20px;
    margin-bottom: -40px;
    margin-left: 20px;
    margin-right: 20px;
  }
  #services {
    margin-top: -40px;
    margin-bottom: 0px;
    margin-left: 20px;
    margin-right: 20px;
  }
}

.home-grid {
  display: grid;
  grid-template-rows: 1fr auto 1fr;
  height: 100%;
  width: 100%;
}

.center-card-wrapper {
  display: flex;
  justify-content: center;
}

.priority-listing-slot {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 0;
  width: 100%;
  > * {
    width: 80%;
    max-width: 900px;
  }
}

.listing-fade-enter-active,
.listing-fade-leave-active {
  transition: opacity 0.8s ease;
}

.listing-fade-enter,
.listing-fade-leave-to {
  opacity: 0;
}
</style>
